import {useState} from 'react';

import Icon from 'components/Icon/Icon';
import {postThumbnailFitTypes} from 'features/postGenerator/typescript';
import useOnClickOutside from 'hooks/useOnClickOutside';
import './SelectPostThumbnailFitType.scss';
import {capitalizeFirstLetter} from 'utils/helpers/capitalizeFirstLetter';

interface IProps {
  value: postThumbnailFitTypes;
  onChange: (value: postThumbnailFitTypes) => void;
}

export default function SelectPostThumbnailFitType({value, onChange}: IProps) {
  const [isOpen, setIsOpen] = useState(false);

  const {containerRef} = useOnClickOutside<HTMLDivElement>(() => setIsOpen(false));

  return (
    <div
      ref={containerRef}
      className={`select-post-thumbnail-fit-type ${isOpen ? 'select-post-thumbnail-fit-type--open' : ''}`}
    >
      <button className="select-post-thumbnail-fit-type__btn" onClick={() => setIsOpen(!isOpen)}>
        {capitalizeFirstLetter(value.toLowerCase())}
        <Icon icon="chevron-down" />
      </button>
      {isOpen && (
        <ul className="select-post-thumbnail-fit-type__options">
          {(Object.keys(postThumbnailFitTypes) as (keyof typeof postThumbnailFitTypes)[]).map((fitTypeKey) => (
            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
            <li
              key={fitTypeKey}
              className="select-post-thumbnail-fit-type__option"
              onClick={() => {
                onChange(postThumbnailFitTypes[fitTypeKey]);
                setIsOpen(false);
              }}
            >
              {capitalizeFirstLetter(postThumbnailFitTypes[fitTypeKey].toLowerCase())}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
